import { Component, OnInit } from '@angular/core';
import {DoctorsService} from "../../services/doctors.service";


@Component({
  selector: 'app-doctors',
  templateUrl: './doctors.component.html',
  styleUrls: ['./doctors.component.css']
})
export class DoctorsComponent implements OnInit {

  data: any = []

  constructor(private doctorService: DoctorsService) { }

  ngOnInit() {
    this.doctorService.getAll()
      .subscribe(doctors => {
          this.data = doctors
        },
        error => {
          alert("Could not fetch all doctors")
        })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/doctors/doctors.component.ts